// /deskStructure.js
import S from '@sanity/desk-tool/structure-builder'

export default () =>
    S.list()
        .title('Content')
        .items([
            S.listItem()
                .title('Homepage')
                .child(
                    S.document()
                        .schemaType('homepage')
                        .documentId('homepage')
                ),
            S.listItem()
                .title('About')
                .child(
                    S.document()
                        .schemaType('about')
                        .documentId('about')
                ),
            S.listItem()
                .title('Contact')
                .child(
                    S.document()
                        .schemaType('contact')
                        .documentId('contact')
                ),
            ...S.documentTypeListItems().filter(listItem => ['news'].includes(listItem.getId())),
            S.divider(),
            ...S.documentTypeListItems().filter(listItem => ['work', 'workType', 'workLocation', 'workMedium'].includes(listItem.getId())),
            S.divider(),
            S.listItem()
                .title('Page Settings')
                .child(
                    S.document()
                        .schemaType('settings')
                        .documentId('settings')
                ),
        ])


// WEBPACK FOOTER //
// ./deskStructure.js